module.exports = __webpack_public_path__ + "static/media/fff-light-circular.4427bab7.png";